import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import KIcon from '@kso/ui/lib/Icon';
import '@kso/ui/lib/Icon/style.css';
import VueAbbr from '@kso/ui/lib/VueAbbr';
import '@kso/ui/lib/VueAbbr/style.css';
import last from 'lodash/last';
import { getFileIcon } from '@kso/util';
import { t } from '@kso/ui/lib/config/locale';
import { fetchGroupFiles } from '@kso/ui/lib/request';
import Emitter from 'element-ui/lib/mixins/emitter';
import ElTooltip from 'element-ui/lib/tooltip';
import 'element-ui/lib/theme-chalk/tooltip.css';
import { subFileName } from '@kso/ui/lib/utils';
import DompurifyHtml from '@kso/ui/lib/utils/v-dompurify-html';

var extMapping = {
  'img': ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'heic', 'webp'],
  // psd不支持预览
  'zip': ['zip', '7z', 'rar', 'iso'],
  'code': ['php', 'py', 'xml', 'js', 'less', 'sass', 'jade', 'css', 'html', 'htm', 'java'],
  'doc': ['wps', 'wpt', 'doc', 'docx', 'dot', 'rtf', 'xml', 'docm', 'dotm'],
  'xls': ['et', 'ett', 'xls', 'xlsx', 'xlsm', 'xlsb', 'xlam', 'xltx', 'xltm', 'xls', 'xlt', 'xla', 'xlw', 'odc', 'uxdc', 'dbf', 'prn'],
  'csv': ['csv'],
  'ppt': ['dps', 'dpt', 'pptx', 'ppt', 'pptm', 'ppsx', 'pps', 'ppsm', 'potx', 'pot', 'potm', 'wpd'],
  'text': ['txt'],
  'pdf': ['pdf'],
  'wxls': ['wxls'],
  'wdoc': ['wdoc'],
  'pom': ['pom'],
  'wppt': ['wppt'],
  'h5': ['h5'],
  'note': ['wpsnote']
};
function getExtName(filename) {
  var ftype = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (~['folder', 'delfolder'].indexOf(ftype)) {
    return 'folder';
  }
  var fileSplit = filename ? filename.split('.') : 'unknown';
  var imgList = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'heic', 'webp'];
  var ext;
  if (fileSplit.length === 1 && ftype !== 'file' && ftype !== 'delfile' && ftype !== 'sharefile') {
    return 'folder';
  }
  ext = fileSplit.length === 1 ? 'unknown' : last(fileSplit).toLowerCase();
  if (imgList.indexOf(ext) !== -1) {
    ext = 'img';
  }
  return ext;
}
function icon(filename, filetype) {
  var fileSplit = filename ? filename.split('.') : 'unknown';
  if (fileSplit.length === 1 && filetype !== 'file' && filetype !== 'delfile' && filetype !== 'sharefile') {
    return 'folder';
  }
  // var ext = _.last(fileSplit).toLowerCase()
  var ext = fileSplit[fileSplit.length - 1].toLowerCase();
  var mapping = extMapping;
  var res = 'unknown';
  if (fileSplit.length !== 1) {
    Object.keys(mapping).forEach(function (icon) {
      if (~mapping[icon].indexOf(ext)) {
        res = icon;
        return false;
      }
    });
  }
  return res;
}

var filters = {
  _ext: function _ext(file) {
    if (file.ftype === 'folder') {
      return t('combine.mainList.finder');
    } else {
      var ext = getExtName(file.fname);
      return (ext === 'img' ? file.fname.split('.').pop() : ext).toUpperCase();
    }
  },
  _yunIcon: function _yunIcon(file) {
    var ftype = file.ftype,
      type = file.type,
      name = file.name,
      fname = file.fname,
      folderAcl = file.folder_acl;
    var isCurFolderPerChanged = folderAcl && (folderAcl.read_type === 'part' || folderAcl.write_type === 'part');

    // 如果本目录设置过权限，则展示上锁文件夹图标，否则走正常的图标filter
    if (ftype === 'folder' && isCurFolderPerChanged) {
      return 'secret-folder';
    } else if (ftype === 'sharefolder' || ftype === 'linkfolder') {
      return 'share-folder2';
    } else if (type === 'normal' && file.corpid === 0 && file.source === 'tags') {
      // 星标tab 个人用户的“与我共享”的星标团队
      return 'share-folder2';
    } else if (ftype === 'devices') {
      return 'devices';
    } else if (ftype === 'secretfolder') {
      return 'secret-folder';
    } else if (type === 'normal' || type === 'corpnormal' || type === 'corpspecial' || ftype === 'delgroup' || ftype === 'linkfolder') {
      return 'share-folder';
    } else if (type === 'loading') {
      return 'wps-file-loading';
    } else if (ftype === 'folder' || ftype === 'delfolder') {
      return 'folder';
    } else {
      return getFileIcon(name || fname, ftype);
    }
  },
  _icon: function _icon(file) {
    var ftype = file.ftype,
      type = file.type,
      name = file.name,
      fname = file.fname;
    if (type === 'normal') {
      return 'wps-team-folder-s';
    } else if (type === 'loading') {
      return 'wps-file-loading';
    } else if (!ftype || ftype === 'folder' || ftype === 'delfolder') {
      return 'folder';
    } else {
      return icon(name || fname, ftype);
    }
  },
  _selected: function _selected(file, selected) {
    var id = file.id,
      fileid = file.fileid;
    return !!selected.find(function (i) {
      return i === (id || fileid);
    });
  }
};

var NewFolder = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('span', {
      staticClass: "folder-name"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.item.name,
        expression: "item.name"
      }],
      ref: "kFinderNew",
      staticClass: "input-new",
      attrs: {
        "id": "kFinderNew",
        "type": "text",
        "autofocus": ""
      },
      domProps: {
        "value": _vm.item.name
      },
      on: {
        "keyup": function keyup($event) {
          if (!$event.type.indexOf('key') && $event.keyCode !== 13) {
            return null;
          }
          return _vm.enter($event);
        },
        "blur": function blur($event) {
          return _vm.item.cb(_vm.item.name);
        },
        "input": function input($event) {
          if ($event.target.composing) {
            return;
          }
          _vm.$set(_vm.item, "name", $event.target.value);
        }
      }
    })]);
  },
  staticRenderFns: [],
  mixins: [Emitter],
  props: {
    item: {
      type: Object,
      "default": function _default() {}
    }
  },
  mounted: function mounted() {
    this.$refs['kFinderNew'].select();
  },
  methods: {
    enter: function enter() {
      this.$refs['kFinderNew'].blur();
    }
  }
};

// 待办支持的文件类型
var todoSupportType = ['doc', 'docx', 'rtf', 'txt', 'xml', 'mhtml', 'mht', 'html', 'htm', 'uof', 'dot', 'wps', 'wpt', 'dotx', 'docm', 'dotm', 'et', 'ett', 'xls', 'xlsx', 'xlsm', 'xlsb', 'xlam', 'xltx', 'xltm', 'xls', 'xlt', 'xla', 'xlw', 'odc', 'uxdc', 'dbf', 'prn', 'wxls', 'csv', 'ppt', 'pptx', 'pptm', 'ppsx', 'ppsm', 'pps', 'potx', 'potm', 'dpt', 'dps', 'pot', 'pdf', 'jpg', 'jpeg', 'png', 'gif', 'bmp', 'heic', 'webp', 'pom', 'pof'];
// 会议支持的文件类型, 注意另一个地方也有这份配置:supportExts
var mettingSupportType = ['et', 'ett', 'xls', 'xlt', 'xlsx', 'xlsm', 'xltx', 'xltm', 'csv', 'doc', 'docx', 'rtf', 'txt', 'xml', 'mhtml', 'mht', 'html', 'htm', 'uof', 'dot', 'wps', 'wpt', 'dotx', 'docm', 'dotm', 'ppt', 'pptx', 'pptm', 'ppsx', 'ppsm', 'pps', 'potx', 'potm', 'dpt', 'dps', 'pot', 'pdf', 'jpg', 'jpeg', 'png', 'gif', 'bmp', 'img', 'heic', 'webp'];
var FinderMainList = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "k-finder-main-list",
      attrs: {
        "id": "kFinderList"
      },
      on: {
        "scroll": _vm.onScroll
      }
    }, [_vm._l(_vm.items, function (item, index) {
      return [_c('div', {
        key: index,
        staticClass: "item-folder",
        "class": {
          disabled: !_vm.selectable(item),
          active: _vm.activeItem(item)
        },
        on: {
          "click": function click($event) {
            return _vm.onItemClick(item);
          },
          "dblclick": function dblclick($event) {
            return _vm.doubleClickHandler(item);
          }
        }
      }, [_vm.source.routeName === 'Tags' ? _c('KIcon', {
        staticClass: "folder-icon",
        attrs: {
          "type": _vm._f("_yunIcon")(Object.assign(item, {
            source: 'tags'
          }))
        }
      }) : _c('KIcon', {
        staticClass: "folder-icon",
        attrs: {
          "type": _vm._f("_yunIcon")(item)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "list-wrap",
        "class": {
          'no-src': _vm.noSrc
        }
      }, [_c('div', [_c('el-tooltip', {
        attrs: {
          "disabled": !_vm.disabledItem(item) || !_vm.limitedCompany.tips,
          "popperClass": "k-finder-disabled-tips right",
          "effect": "dark",
          "placement": "right"
        }
      }, [_c('span', {
        staticClass: "content",
        attrs: {
          "slot": "content"
        },
        slot: "content"
      }, [_c('span', [_vm._v(_vm._s(_vm.limitedCompany.tips))])]), _vm._v(" "), item["new"] ? _c('new-folder', {
        attrs: {
          "item": item
        }
      }) : _vm.source.routeName === 'Search' ? _c('span', {
        staticClass: "folder-name",
        on: {
          "click": function click($event) {
            $event.stopPropagation();
            return _vm.onItemClick(item, true);
          }
        }
      }, [_c('span', {
        directives: [{
          name: "dompurify-html",
          rawName: "v-dompurify-html",
          value: _vm.fileNameHl(item),
          expression: "fileNameHl(item)"
        }],
        staticClass: "folder-search"
      })]) : _c('span', {
        staticClass: "folder-name",
        on: {
          "click": function click($event) {
            $event.stopPropagation();
            return _vm.onItemClick(item, true);
          }
        }
      }, [_c('vue-abbr', {
        attrs: {
          "text": _vm.getItemName(item.name || item.fname)
        }
      })], 1)], 1)], 1), _vm._v(" "), item.src ? _c('div', {
        staticClass: "src"
      }, [_vm._v(_vm._s(item.src))]) : _vm._e()]), _vm._v(" "), _c('el-tooltip', {
        attrs: {
          "disabled": !_vm.disabledFType(item) || !_vm.disableFileType[item.ftype],
          "popperClass": "k-finder-disabled-tips",
          "effect": "dark",
          "placement": "left"
        }
      }, [_c('span', {
        staticClass: "content",
        attrs: {
          "slot": "content"
        },
        slot: "content"
      }, [_c('span', [_vm._v(_vm._s(_vm.disableFileType[item.ftype]))])]), _vm._v(" "), _vm.showCheckBox(item) ? _c('div', {
        staticClass: "item-checkbox-label"
      }) : _vm._e()])], 1)];
    })], 2);
  },
  staticRenderFns: [],
  name: 'KFinderMainList',
  components: {
    KIcon: KIcon,
    VueAbbr: VueAbbr,
    NewFolder: NewFolder,
    ElTooltip: ElTooltip
  },
  filters: filters,
  mixins: [Emitter],
  props: {
    actionType: {
      type: String
    },
    items: {
      type: Array
    },
    source: {
      type: Object
    },
    secretLocked: {
      type: Boolean
    },
    isSelectFile: {
      type: Boolean
    },
    isMulti: {
      type: Boolean
    },
    isCrossGroup: {
      type: Boolean
    },
    selectedFile: {
      type: Object
    },
    disableFileType: {
      type: Object
    },
    limitedCompany: {
      type: Object
    },
    isSecretExpired: {
      type: Boolean
    },
    limitedExtArr: {
      type: Array,
      "default": function _default() {
        return [];
      }
    }
  },
  directives: {
    'dompurify-html': DompurifyHtml
  },
  data: function data() {
    return {
      checkedFileIDs: [],
      checkedFileInfoArr: []
    };
  },
  computed: {
    noSrc: function noSrc() {
      return this.source.routeName !== 'Latest' && this.source.routeName !== 'Search';
    }
  },
  watch: {
    source: function source() {
      this.checkedFileIDs = [];
      this.checkedFileInfoArr = [];
    }
  },
  methods: {
    getExtName: function getExtName(fname) {
      var fileSplit = fname ? fname.split('.') : 'unknown';
      return fileSplit.length === 1 ? 'unknown' : last(fileSplit).toLowerCase();
    },
    getItemName: function getItemName(fname) {
      // 提纲不显示后缀
      if (this.getExtName(fname) === 'otl') {
        return subFileName(fname);
      } else {
        return fname;
      }
    },
    disabledItem: function disabledItem(item) {
      var companyID = Number(this.source.corpid || item.corpid || item.id);
      var isFile = item.ftype === 'file' || item.ftype === 'sharefile';
      if (this.limitedCompany.id && !isFile) {
        if (item) {
          return companyID !== Number(this.limitedCompany.id);
        }
      }
      return false;
    },
    selectable: function selectable(item) {
      var isFile = item.ftype === 'file' || item.ftype === 'sharefile';
      if (this.limitedCompany.id) {
        var companyID = Number(this.source.corpid || item.corpid || item.id);
        if (companyID !== Number(this.limitedCompany.id)) {
          return false;
        }
      }
      if (this.disabledFType(item)) {
        return false;
      }
      if (isFile) {
        var fname = item.name || item.fname;
        var ext = this.getExtName(fname);
        if (!this.supportType(fname)) {
          return false;
        }
        // 如果限制了格式
        if (this.isSelectFile) {
          // 选择文件
          if (this.limitedExtArr && this.limitedExtArr.length) {
            // 限制了格式
            return this.limitedExtArr.includes(ext);
          } else {
            // 未限制格式
            return true;
          }
        } else {
          // 选择文件夹,文件不可点
          return false;
        }
      }
      return true; // 文件夹都可点
    },
    showCheckBox: function showCheckBox(item) {
      // 仅多选显示复选框
      if (!this.isMulti) {
        return false;
      }

      // 仅以下路由可多选
      if (this.isCrossGroup) {
        if (!['All', 'Team', 'Enterprise', 'Device', 'Secret', 'Latest', 'Sharing', 'Tags', 'Search'].includes(this.source.routeName)) {
          return false;
        }
      } else {
        if (!['All', 'Team', 'Enterprise', 'Device', 'Secret'].includes(this.source.routeName)) {
          return false;
        }
      }

      // 设备与私密文件夹不可多选
      if (['devices', 'device', 'secretfolder'].includes(item.ftype)) {
        return false;
      }

      // 企业下的团队列表不可多选
      if (this.source.routeName === 'Enterprise' && !this.source.groupid) {
        return false;
      }

      // 限制了格式, 其他的不可选
      if (this.limitedExtArr.length) {
        var name = item.name || item.fname;
        var ext = this.getExtName(name);
        return this.limitedExtArr.includes(ext);
      }
      return true;
    },
    disabledFType: function disabledFType(item) {
      return Object.keys(this.disableFileType).includes(item.ftype);
    },
    activeItem: function activeItem(item) {
      if (this.isMulti) {
        return this.checkedFileIDs.includes(item.id);
      } else {
        return item.id && item.id === this.selectedFile.id;
      }
    },
    supportType: function supportType(fname) {
      var isMeeting = this.actionType === 'meeting';
      var isTODO = this.actionType === 'todo';
      var ext = this.getExtName(fname);
      var isTodoSupportType = todoSupportType.indexOf(ext) !== -1;
      var isMettingSupportType = mettingSupportType.indexOf(ext) !== -1;
      if (!isTODO && !isMeeting || isTODO && isTodoSupportType || isMeeting && isMettingSupportType) {
        return true;
      } else {
        return false;
      }
    },
    // 滚动事件
    onScroll: function onScroll() {
      var _this = this;
      if (this.loadingMore || this.flag) {
        return;
      }
      // 没有正在加载数据，而且还有更多数据，并且到达滚动条底部，则加载更多数据
      var _this$$el = this.$el,
        clientHeight = _this$$el.clientHeight,
        scrollTop = _this$$el.scrollTop,
        scrollHeight = _this$$el.scrollHeight;
      if (clientHeight + scrollTop + 10 >= scrollHeight && scrollTop > 0) {
        this.flag = true;
        this.$emit('loadmore');
        setTimeout(function () {
          _this.flag = false;
        }, 200);
      }
    },
    // 文件名高亮，兼容旧接口
    fileNameHl: function fileNameHl(item) {
      var name = item.name,
        fname = item.fname,
        type = item.type,
        ftype = item.ftype,
        highlight = item.highlight;
      var _name = name || fname;
      var _type = ftype || type;
      if (highlight) {
        var file_name = highlight.file_name,
          group_name = highlight.group_name;
        if (highlight.file_name && file_name.length) {
          // 新搜索接口将文件名和高亮信息储存在 file_name 中
          return this.fileContentHl(file_name[0]);
        }
        // 圈子高亮
        if (highlight.group_name && group_name.length) {
          return this.fileContentHl(group_name[0]);
        }
      }
      // 兼容旧接口，旧接口文件名使用 fname，用正则匹配高亮
      return this.keywordHl(_name, _type);
    },
    // 使用正则匹配高亮，不用接口信息
    keywordHl: function keywordHl(fname) {
      // 合并关键词
      var kw = this.source.keyword && this.source.keyword.replace(/[-\\/^$*+?.()|[\]{}]/g, '\\$&') || '';
      return fname.replace(new RegExp("".concat(kw, "+"), 'ig'), function ($1) {
        return '<em>' + $1 + '</em>';
      });
    },
    fileContentHl: function fileContentHl() {
      var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      /*
       * 第一个 replace 是为了去除 <em> 以外的标签
       * 第二个 replace 是为了将多个高亮连在一起
       * 第三个 replace 是为了将最后单独的<em>剔除
       */
      return content.replace(/<\/?[\s\S]+?>/ig, function ($1) {
        if (!/<\/?\s*em\s*[\s\S]*>/i.test($1)) {
          return '';
        }
        return $1;
      }).replace(/<\/em><em>/ig, '').replace(/<em>$/ig, '');
    },
    doubleClickHandler: function doubleClickHandler(item) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (item) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              if (!_this2.isMulti) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              if (!(item.ftype === 'file' || item.ftype === 'sharefile')) {
                _context.next = 9;
                break;
              }
              if (!_this2.selectable(item)) {
                _context.next = 9;
                break;
              }
              _context.next = 8;
              return _this2.onItemClick(item);
            case 8:
              _this2.dispatch('KFinder', 'commit');
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    onItemClick: function onItemClick(item, isFileNameClicked) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var isFile, companyID, index, routeName, target, groupid, linkgroupid, data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              isFile = item.ftype === 'file' || item.ftype === 'sharefile'; // 限制了企业
              if (!_this3.limitedCompany.id) {
                _context2.next = 5;
                break;
              }
              companyID = Number(_this3.source.corpid || item.corpid || item.id);
              if (!(companyID !== Number(_this3.limitedCompany.id))) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return");
            case 5:
              if (!item["new"]) {
                _context2.next = 7;
                break;
              }
              return _context2.abrupt("return");
            case 7:
              if (_this3.selectable(item)) {
                _context2.next = 9;
                break;
              }
              return _context2.abrupt("return");
            case 9:
              if (!_this3.isMulti) {
                _context2.next = 16;
                break;
              }
              if (!(!_this3.showCheckBox(item) && !isFileNameClicked)) {
                _context2.next = 12;
                break;
              }
              return _context2.abrupt("return");
            case 12:
              if (!(isFile || !isFileNameClicked)) {
                _context2.next = 16;
                break;
              }
              if (!_this3.checkedFileIDs.includes(item.id)) {
                _this3.checkedFileInfoArr.push(item);
                _this3.checkedFileIDs.push(item.id);
              } else {
                index = _this3.checkedFileIDs.findIndex(function (v) {
                  return v === item.id;
                });
                _this3.checkedFileInfoArr.splice(index, 1);
                _this3.checkedFileIDs.splice(index, 1);
              }
              _this3.dispatch('KFinder', 'selectMultiFile', [{
                groupid: item.groupid,
                fileids: _this3.checkedFileIDs,
                fileInfoArr: _this3.checkedFileInfoArr
              }]);
              return _context2.abrupt("return");
            case 16:
              if (!isFile) {
                _context2.next = 18;
                break;
              }
              return _context2.abrupt("return", _this3.dispatch('KFinder', 'selectFile', item));
            case 18:
              routeName = _this3.source.routeName;
              target = Object.assign({}, item);
              if (target.corpid) {
                target.routeName = 'Enterprise';
              } else if (target.routeName !== 'All') {
                target.routeName = 'Team';
              }
              if (!(item.ftype === 'sharefolder')) {
                _context2.next = 25;
                break;
              }
              target.routeName = 'Sharing'; // 共享文件夹
              _context2.next = 54;
              break;
            case 25:
              if (!(item.ftype === 'secretfolder')) {
                _context2.next = 33;
                break;
              }
              if (!_this3.secretLocked) {
                _context2.next = 30;
                break;
              }
              return _context2.abrupt("return", _this3.dispatch('KFinder', 'openSecretFolder'));
            case 30:
              return _context2.abrupt("return", _this3.dispatch('KFinder', 'source', {
                routeName: 'Secret'
              }));
            case 31:
              _context2.next = 54;
              break;
            case 33:
              if (!(item.ftype === 'devices')) {
                _context2.next = 37;
                break;
              }
              target.routeName = 'Devices';
              _context2.next = 54;
              break;
            case 37:
              if (!(item.ftype === 'device')) {
                _context2.next = 41;
                break;
              }
              target.routeName = 'Device';
              _context2.next = 54;
              break;
            case 41:
              if (item.share_type === 'group') {
                target.routeName = 'Sharing';
              }
              _context2.t0 = routeName;
              _context2.next = _context2.t0 === 'Enterprise' ? 45 : _context2.t0 === 'Tags' ? 45 : _context2.t0 === 'Secret' ? 52 : 54;
              break;
            case 45:
              if (target.corpid) {
                _context2.next = 51;
                break;
              }
              groupid = target.groupid, linkgroupid = target.linkgroupid;
              _context2.next = 49;
              return fetchGroupFiles(linkgroupid || groupid);
            case 49:
              data = _context2.sent;
              if (data.corpid > 0) {
                target.corpid = data.corpid;
                target.routeName = 'Enterprise';
                target.currentTeam = data;
              }
            case 51:
              return _context2.abrupt("break", 54);
            case 52:
              target.routeName = 'Secret';
              return _context2.abrupt("break", 54);
            case 54:
              _this3.dispatch('KFinder', 'source', target);
            case 55:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};

FinderMainList.install = function (Vue) {
  Vue.component(FinderMainList.name, FinderMainList);
};

export { FinderMainList as default };
